import { Component, OnInit } from '@angular/core';
import { ViewState } from 'src/common';

@Component({
  selector: 'request-edit',
  templateUrl: 'request-edit.component.html'
})

export class RequestEditComponent implements OnInit {

  viewState = ViewState;

  constructor() { }

  ngOnInit() { }
}
